(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Validation, Config, Helper, Service, Handler, Model, Message, Analytics, $) {
    'use strict';

    /*
        Para agregar una validacion por expresion reguar:
        1. Agregar el regex en validators
        2. Agregar el mensaje en caso de error
        3. Agregar la class v-xxxx al input

        Para agregar una validacion por funcion:
        1. Agregar agregar la funcion extendiendo Validation.
        2. Agregar al switch de Validation.byFunction el nombre de la funcion
        3. Agregar el mensaje en caso de error
        4. Agregar la class v-xxxx al input
    */


    Validation.Validators = {
        required: /(.)/,
        text: /^[A-Za-zÀ-ÿ ]$/,
        numeric: /^\d+$/,
        email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        name: /^[A-Za-zÀ-ÿ ']{3,50}$/,
        lastname: /^[A-Za-zÀ-ÿ ]{3,50}$/,
        credencialClub: /^[0-9]{15}?/,
        credencialClub1: /^[0-9]{6}?/,
        credencialClub2: /^[0-9X]{8}?/,
        credencialClub3: /^[0-9]{2}?/,
        tarjeta: /^[0-9]{15,16}$/,
        tarjeta_amex: /^[0-9]{15}$/,
        tarjeta_otras: /^[0-9]{16}$/,
        tarjeta_dinners: /^[0-9]{14}$/,
        dni: /^[1-9][0-9]{6,7}$/,
        passport: /^[A-Za-z0-9]{6,10}$/,
        visa: /^(?:4[0-9]{12}(?:[0-9]{3})?)$/,
        mastercard: /^(?:5[1-5][0-9]{14})$/,
        amex: /^(?:3[47][0-9]{13})$/,
        discover: /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/,
        temporary: /loginTemporalKey/,
        lettersonly: /^[A-Za-zÀ-ÿ ']*$/,
        nameLen2: /^.{2,}$/,
        until50: /^[A-Za-zÀ-ÿ ']{0,50}$/,
        until5: /^[A-Za-zÀ-ÿ 0-9]{1,5}$/,
        surnameLen2: /^.{2,}$/,
        phone: /^\d*$/,
        phonefrom6: /^(\d{6,9999})?$/,
        phoneUntil17: /^\d{6,17}$/,
        numeric_cp: /^[1-9][0-9]*$/,
        numeric_cp_ext: /^[0-9]*$/,
        numeric_cp_arg: /^[1-9][0-9]*$/,
        numeric_dni: /^[1-9][0-9]*$/,
        numeric_from_4: /^\d{4,5}$/,
        street: /^[A-Za-zÀ-ÿ 0-9\']*$/,
        piso: /^[A-Za-zÀ-ÿ 0-9]*$/
    };

    Validation.Messages = {
        /* Validaciones generales */
        text: 'El campo debe ser un texto',
        numeric: 'El número no es válido, ingresá sólo números sin guiones, puntos ni espacios',
        num_invalido: 'Número inválido',
        email: 'El e-mail es inválido',
        passport: 'Tenés que ingresar un pasaporte válido',
        doc_type: 'Ingrese un documento valido',
        error_credencial_incorrecta: ' El número de tarjeta es incorrecto',
        tc_invalida: 'Ingresá un número de tarjeta válido',
        tc_incorrecta: 'Los datos ingresados son incorrectos',
        tc_vencimiento: 'Ingresá una fecha de vencimiento válida',
        /*datos personales*/
        lettersonly: 'Solamente se admiten letras, espacios y un apóstrofe',
        nameLen2: 'Tu nombre debe tener al menos dos caracteres',
        surnameLen2: 'Tu apellido debe tener al menos dos caracteres',
        until50: 'El campo acepta hasta 50 caracteres',
        phone: 'Sólo se aceptan números sin guiones, puntos ni espacios',
        phonefrom6: 'Por lo menos 6 caracteres',
        phoneUntil17: 'El campo acepta hasta 17 caracteres',
        phone_diferentes: 'El telefono celular y particular no pueden ser iguales',
        numeric_cp: 'Debe ser numerico.',
        numeric_dni: 'Debe ser numerico.',
        numeric_from_4: 'Por lo menos 4 digitos',
        street: 'Solo acepta numeros y letras',
        piso: 'Solo acepta numeros y letras',
        /* Validación de campos obligatorios */
        required: 'Campo obligatorio',
        campos_obligatorios: 'Todos los campos con (*) son datos obligatorios',
        required_cp: 'El campo código postal, es obligatorio',
        required_provincia: 'El campo localidad, es obligatorio',
        required_partido: 'El campo partido, es obligatorio',
        codigo_postal_extranjero: 'Código postal inválido',
        /* TARJETA */
        tarjeta: 'Ingresá un número de tarjeta válido.',
        tarjeta_incorrecta: 'Número de tarjeta incorrecto',
        tarjeta_incompleta: 'Número de tarjeta incompleto',
        tarjetas_ultimos_dos: 'Los números ingresados son incorrectos. Ingresá los dos últimos números de tu tarjeta.',

        tarjeta_amex: 'Ingresá un número de tarjeta válido.',
        tarjeta_otras: 'Ingresá un número de tarjeta válido.',
        tarjeta_dinners: 'Ingresá un número de tarjeta válido.',

        /* ASOCIACION */
        doc_incompleto: 'Revisa que el número de documento esté completo',
        pasaporte_incompleto: 'Revisa que el número de pasaporte esté completo y contenga letras y números',
        le_incompleto: 'Revisa que el número de LE esté completo',
        /*MENSAJE AMARILLO*/
        error_compra: 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente'
    };

    Validation.Validators.Max = {
        name: 50,
        lastname: 50,
        confirmCode: 24,
        credencialClub: 15,
        credencialClub1: 5,
        credencialClub2: 7,
        credencialClub3: 1,
        dni: 8,
        passport: 10
    };

    Validation.checkValidations = function (s, d, a, e) {
        // Si no tiene clase v-* no valida y retorna true.
        if (!s.is('[class*="v-"]')) return true;
        if (s.is('[disabled=disabled]')) return true;
        if (isNaN(a)) a = true; // true por defecto.        
        var validators = ((s.is(':input') && !s.hasClass('v-no-validate')) ? s.attr('class').split(" ") : {});
        var response = true;
        for (var key in validators) {
            var v = validators[key].replace('v-', '');
            if (v == '') {
                break;
            }
            //  Validación por expresion regular.
            if (Validation.Validators[v] && !Validation.Validators[v].test(s.val())) {
              Helper.changeStatus(s, false, Validation.Messages[v]);
                if (a) Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[v]);
                response = false;
                break;
            } else {
                response = response && Validation.byFunction(v, s, d, a, e);
                if (!response) {
                    break;
                } else {
                    Helper.changeStatus(s, true);
                }
            }
        }
        return response;
    }
    Validation.checkKeyUp = function (s, e) {
        // Primero chequeamos el length
        //console.log('keyCode:' + e.keyCode);
        let except = [8, 9, 13, 33, 34, 35, 36, 37, 39, 46];
        let block = [38, 40];
        let maxlenth = s.attr('maxlength');
        if (maxlenth && !except.includes(e.keyCode)) { // Tiene maxlength
            let length = s.val().length;
            if (length >= parseInt(maxlenth)) {
                // Supera la maxima, bloqueo caracteres
                e.preventDefault();
                return false;
            }
        }

        // si no hay validacion de keydown, retorno true
        if (!s.is('[class*="k-"]')) return true;
        var validators = s.attr('class').split(' ');
        var response = true;
        for (var key in validators) {
            if (!/k-/.test(validators[key])) continue;
            if (except.includes(e.keyCode)) return;
            if ((s.attr('type') !== 'number') && block.includes(e.keyCode)) return false;
            var v = validators[key].replace('k-', '');
            if (v == '') {
                break;
            }

            
            if (!Validation.Validators[v].test(e.key)) {
                e.preventDefault();
                response = false;
            }
        }
        return response;
    }


    Validation.cleanOnFocusIn = function () {
        $(document.body).on('focusin ', ':input', function (event) {
            Helper.cleanStatus($(this))
        });
    }

    Validation.validateOnFocus = function () {
        $(document.body).on('change', 'select', function (event) {
            Validation.attachValidationProcess($(this));
        });
        $(document.body).on('focusout ', ':input', function (event) {
            Validation.attachValidationProcess($(this));
        });
        $(document.body).on('keydown', ':input', function (event) {

            return Validation.checkKeyUp($(this), event);
        });
    }

    Validation.attachValidationProcess = function (element) {
        if (Config.disableValidations === true) {
            return true;
        }
        if (element.hasClass("v-no-validate")) {
            return true;
        }
        if (element.val() === '') {
            Helper.cleanStatus(element);
        } else if (Validation.checkValidations(element) && element.val() !== '') {
            Helper.changeStatus(element, true);
        }
    }

    Validation.validateOnKeyDownOnlyNumbers = function () {
        $(document.body).on('keydown', '.e-solo_numeros', function (e) {
            if ($(this).attr('type') !== 'number') return;
            var keycode = e.which;
            if ((e.ctrlKey && keycode == 67) || (e.ctrlKey && keycode == 86)) return true;
            if ((keycode == 13 || keycode == 32 || keycode == 38 || keycode == 40 || keycode == 107 || keycode == 190 || keycode == 187 || keycode == 188 || keycode == 189 || keycode == 109 || (keycode >= 65 && keycode <= 90))) {
                e.preventDefault();
                return false;
            }

            if ((keycode >= 48 && keycode <= 57) || (keycode >= 96 && keycode <= 105)) { // Ingreso numeros, chequeo lenght
                // Verify maxlenght
                let maxlenth = $(this).attr('maxlength');
                if (maxlenth) { // Tiene maxlength
                    let length = $(this).val().length;
                    if (length >= parseInt(maxlenth)) {
                        // Supera la maxima, bloqueo caracteres
                        e.preventDefault();
                        return false;
                    }
                }
            }
        });
    }

    Validation.validateOnSubmit = function (step, disabledValidations) {
        if (Config.disableValidations === true) return true;
        var objects = Model.getInputsBy(step).all();
        for (var key in objects) {
            Validation.checkValidations(objects[key].object, disabledValidations, false, false);
        }
        return ($(".input.error [name^='" + step + "']").length > 0) ? false : true;
    }

    /* EXTENSIONES DE VALIDACIONES */
    Validation.byFunction = function (f, s, d, a, e) {
        // Si la validacion esta deshabilitada
        if (!Helper.isEmpty(d) && !Helper.isEmpty(d[f]) && f == d[f]) return true;
        if (isNaN(a)) a = true;
        switch (f) {
            case 'demo':
                Validation.demo(f, s, a, e)
                break;
            case 'doc_type':
                return Validation.doc_type(f, s, a, e);
            case 'phone_diferentes':
                return Validation.phone_diferentes(f, s, a, e);
            case 'codigo_postal_extranjero':
                return Validation.codigo_postal_extranjero(f, s, a, e);
            case 'normalizar_domicilio':
                return Validation.normalizar_domicilio(f, s, a, e);
            default:
                return true;
        }
    }

    Validation.demo = function (f, s, a) {
        if (s.val() === 'aaaa') {
            Helper.changeStatus(s, true);
            return true;
        }
        Helper.changeStatus(s, false, Validation.Messages[f]);
        return false;
    }


    /* Validacion por DNI o Pasaporte*/
    Validation.doc_type = function (f, s, a, e) {
        var doc_type = Model.getInputsBy('datos_personales', 'tipoDocumento').get().value;
        var response = (doc_type === 'PAS') ? response = Validation.Validators.passport.test(s.val()) : (response = Validation.Validators.dni.test(s.val()) && !(s.val() == 0));
        Helper.changeStatus(s, response, Validation.Messages[f]);
        if (!response && a) {
            Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[f]);
        }
        return response;
    }

    Validation.phone_diferentes = function (f, s, a, e) {
        var telefono = Model.getInputsBy('datos_personales', 'telefonoParticular').get().value;
        var response = (telefono == "");
        Helper.changeStatus(s, response, Validation.Messages[f]);
        if (!response && a) {
            Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[f]);
        }
        return response;
    }

    Validation.codigo_postal_extranjero = function (f, s, a, e) {

        var cp = Model.getInputsBy('datos_envio', 'cp').get().value;

        var response = (Model.getInputsBy('datos_envio', 'pais').get().value === 'AR') ? Validation.Validators.numeric_cp_arg.test(s.val()) : Validation.Validators.numeric_cp_ext.test(s.val());

        Helper.changeStatus(s, response, Validation.Messages[f]);

        if (!response && a) {
            Analytics.formError(Helper.cleanInputName(s) + ' - ' + Validation.Messages[f]);
        }

        return response;
    }

    Validation.normalizar_domicilio = function (f, s, a, e) {
        // No valida nada si no es Argentina
        //if (Model.getInputsBy('datos_envio', 'pais').get().value !== 'AR') return true;
        // Seteo el model hasta tener los 3 campos
        Model.DomicilioElegido.calle = Model.getInputsBy('datos_envio', 'calle').get().value;
        Model.DomicilioElegido.altura = Model.getInputsBy('datos_envio', 'altura').get().value;
        Model.DomicilioElegido.cp = Model.getInputsBy('datos_envio', 'cp').get().value;

        if (!Helper.isEmpty(Model.DomicilioElegido.calle) && !Helper.isEmpty(Model.DomicilioElegido.altura) && !Helper.isEmpty(Model.DomicilioElegido.cp)) {
            Service.domicilioNormalizar(Model.DomicilioElegido, function (res, status, xhr) {


                switch (res.code) {

                    case '0000':
                        if (Model.PlanElegido.planConCredencial) {
                            if (!Helper.isEmpty(res.response.entreCalle1)) {
                                Model.getInputsBy('datos_envio', 'entreCalle1').set(res.response.entreCalle1);
                                Helper.SetFocus('datos_envio', 'entreCalle1');
                            }
                            if (!Helper.isEmpty(res.response.entreCalle2)) {
                                Model.getInputsBy('datos_envio', 'entreCalle2').set(res.response.entreCalle2);
                                Helper.SetFocus('datos_envio', 'entreCalle2');
                            }
                        }
                        if (!Helper.isEmpty(res.response.calle)) {
                            Model.getInputsBy('datos_envio', 'calle').set(res.response.calle);
                        }
                        if (!Helper.isEmpty(res.response.localidad)) {
                            Model.getInputsBy('datos_envio', 'localidad').set(res.response.localidad);
                            Helper.SetFocus('datos_envio', 'localidad');
                        }
                        if (!Helper.isEmpty(res.response.localidad)) {
                            Model.getInputsBy('datos_envio', 'partido').set(res.response.localidad);
                            Helper.SetFocus('datos_envio', 'partido');
                        }
                        if (!Helper.isEmpty(res.response.provincia)) {
                            //Model.getInputsBy('datos_envio', 'provincia').set(res.response.provincia);
                            //Helper.SetFocus('datos_envio', 'provincia');
                            $('select[name="datos_envio[provincia]"]').val(res.response.provincia);
                        }

                        Helper.placeHolderAnimationOnStepLoad();
                        if (Helper.checkIfAddressExist(res.response) !== false) {
                            Model.DomicilioTemp = res.response;
                            Helper.showModalAddress();
                        }
                        break;

                    case '0001':
                        logger && logger.fatal('domicilioNormalizar | Error General (' + res.code + ')');
                        break;
                    default:
                        logger && logger.error('domicilioNormalizar | No existe el codigo (' + res.code + ')');
                        Analytics.formError('Paywall | domicilioNormalizar | ' + res.message);
                        break;
                }
            });
        }
        return true;
    }

})(LN.Validation, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Analytics, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/validation.js